module.exports = function(video) {
	'use strict'
	video.directive('videoTagsDir',videoTagsDir);
	videoTagsDir.$inject=[];
	function videoTagsDir() {
		return {
			template: require('./partial/video-tags.html'),
			controller:'videoTagsController',
			controllerAs:'vmvt',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-tags/js/directive/videoTagsDirective.js
// module id = 656
// module chunks = 0